module.exports = __webpack_public_path__ + "static/media/groupcare_logo_hor.a6855abc.jpg";